import { FC, ReactElement } from "react";

const Copy:FC =():ReactElement=>{
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path d="M18.688 16h7.313l-7.313-7.313v7.313zM20 6.688l8 8v13.313q0 1.063-0.813 1.875t-1.875 0.813h-14.688q-1.063 0-1.844-0.813t-0.781-1.875v-18.688q0-1.063 0.813-1.844t1.875-0.781h9.313zM21.313 1.313v2.688h-16v18.688h-2.625v-18.688q0-1.063 0.781-1.875t1.844-0.813h16z"></path>
        </svg>
    )
}

export default Copy;